<div class="slideshows-page">
  <div class="row">
    @for (item of formattedDatatableRows(); track item) {
      <div class="col-lg-3 col-sm-6 col-xs-12 mb-3">
        <mat-card appearance="outlined">
          <mat-card-header>
            <div mat-card-avatar class="pe-1">
              <img height="40px" src="../../assets/images/modules/digitalBoards.png" />
            </div>
            <mat-card-title class="f-16 text-truncate">{{ item.name }}</mat-card-title>
            <mat-card-subtitle class="f-12 text-grey">{{ item.workspace }}</mat-card-subtitle>
            <div class="card-header-actions">
              <button
                mat-icon-button
                class="card-pin-button"
                [class.pinned]="item.isPinned"
                (click)="togglePin(item)"
                [matTooltip]="(item.isPinned ? 'button.unpin' : 'button.pin') | translate"
              >
                <mat-icon [class.material-icons-outlined]="!item.isPinned">push_pin</mat-icon>
              </button>
              @if (item.isEditableByCurrentUser) {
                <button mat-icon-button (click)="onClickedItem(item.id)" [matMenuTriggerFor]="settingsMenu">
                  <mat-icon>more_vert</mat-icon>
                </button>
              }
            </div>
          </mat-card-header>
          <mat-card-actions class="card-actions-with-chips">
            <div class="card-chip-container">
              <span class="card-chip">
                <mat-icon class="material-icons-outlined">{{ item.isOwnedBySingleUser ? 'person' : 'group' }}</mat-icon>
                {{ (item.isOwnedBySingleUser ? 'field.private' : 'field.shared') | translate }}
              </span>
              <span class="card-chip">
                <mat-icon class="material-icons-outlined">dashboard</mat-icon>
                {{ item.dashboardCount }} {{ 'field.dashboards' | translate }}
              </span>
              <span class="card-chip">
                <mat-icon class="material-icons-outlined">timer</mat-icon>
                {{ item.slideDurationSeconds }} {{ 'field.seconds' | translate }}
              </span>
              @if (item.isAutoLockEffective) {
                <span class="card-chip">
                  <mat-icon class="material-icons-outlined">lock</mat-icon>
                  {{ 'field.autoLock' | translate }}
                </span>
              }
            </div>
            <div class="card-actions-buttons">
              <a [routerLink]="'/slideshows/' + item.id">
                <button mat-stroked-button>
                  {{ 'button.open' | translate }}
                </button>
              </a>
            </div>
          </mat-card-actions>
        </mat-card>
      </div>
    }
  </div>
  <mat-menu class="mt-2" #settingsMenu="matMenu">
    <button mat-menu-item (click)="initializeEdit()">
      {{ 'button.edit' | translate }}
    </button>
    <button mat-menu-item (click)="initializeDelete()">
      {{ 'button.delete' | translate }}
    </button>
  </mat-menu>
</div>

<ng-template #addEditFormDialog>
  <h1 mat-dialog-title>
    {{ addEditModalTitle() }}
  </h1>
  <form [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()" #form="ngForm">
    <div mat-dialog-content>
      <div class="row">
        <div class="col-12 mb-3">
          <span class="dialog-section"
            ><mat-icon>description</mat-icon> {{ 'system.dialogSection.generalInformation' | translate }}</span
          >
        </div>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'field.name' | translate }}</mat-label>
          <input matInput formControlName="name" />
          <mat-error [control]="addEditForm.get('name')"></mat-error>
        </mat-form-field>
        <div class="col-lg-12">
          <mat-dropdown
            [options]="store.workspaces()"
            [configurationInput]="workspaceDropdownConfig"
            [formControl]="addEditForm.controls.workspace"
            [isLoading]="(store.workspacesLoading$ | async) === store.ELoadStatus.loading"
            [isFormSubmitted]="form.submitted"
            (selected)="onSelectedWorkspace()"
            (search)="getWorkspaces($event)"
          ></mat-dropdown>
        </div>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'field.displayInterval' | translate }}</mat-label>
          <input matInput type="number" formControlName="slideDurationSeconds" step="30" min="10" />
          <span matTextSuffix>{{ 'field.seconds' | translate }}</span>
          <mat-error [control]="addEditForm.get('slideDurationSeconds')"></mat-error>
        </mat-form-field>

        <div class="col-12">
          <span class="dialog-section"
            ><mat-icon class="material-icons-outlined">subscriptions</mat-icon>
            {{ 'system.dialogSection.dashboardAssignments' | translate }}</span
          >
        </div>

        <div class="col-12">
          <app-datatable
            [configurationInput]="{
              areCheckboxesEnabled: false,
              isClientSide: true,
              isDraggable: true,
              isHeaderRowEnabled: false,
              isLoaderEnabled: false,
              isPaginationEnabled: false,
              isSearchEnabled: false,
            }"
            [rowData]="dashboardOptionsDatatableRows()"
            [columns]="dashboardOptionsDatatableColumns"
            [total]="10000"
            [customColumnDef]="[
              { name: 'name', template: fieldOptionName, isSortable: false },
              { name: 'delete', template: fieldOptionDelete, isSortable: false },
            ]"
            (rowOrderChange)="dashboardOptionOrders.set($event)"
          />
          <div class="mt-2 mb-3 d-flex gap-2">
            <button mat-stroked-button (click)="addFieldOption()" type="button">
              <mat-icon>add</mat-icon>
              {{ 'button.addContext' | translate: { context: ('field.dashboard' | translate) } }}
            </button>
            <button mat-stroked-button (click)="addUrlOption()" type="button" class="ms-2">
              <mat-icon>add_link</mat-icon>
              {{ 'button.addContext' | translate: { context: 'field.url' | translate } }}
            </button>
          </div>
        </div>

        <div class="col-12">
          <mat-expansion-panel [expanded]="isExtendedAccessPanel">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon class="me-2 material-icons-outlined">groups</mat-icon>
                {{ 'system.dialogSection.accessAndPermissions' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="col-lg-12">
              <mat-dropdown
                [isFormSubmitted]="form.submitted"
                [options]="store.adminOptions()"
                [configurationInput]="{
                  text: ('field.canEdit' | translate),
                  repositionDropdownList: true,
                  hasDelayedDefaultValue: true,
                }"
                [formControl]="addEditForm.controls.admins"
                [isLoading]="(store.adminOptionsLoading$ | async) === store.ELoadStatus.loading"
                (search)="getAdmins($event)"
              ></mat-dropdown>
            </div>
            <div class="col-lg-12">
              <mat-dropdown
                [options]="store.userOptions()"
                [configurationInput]="{
                  text: ('field.canView' | translate),
                  repositionDropdownList: true,
                  hasDelayedDefaultValue: true,
                }"
                [formControl]="addEditForm.controls.users"
                [isLoading]="(store.userOptionsLoading$ | async) === store.ELoadStatus.loading"
                (search)="getUsers($event)"
              ></mat-dropdown>
            </div>
            <div class="col-lg-12">
              <mat-dropdown
                [options]="store.teamOptions()"
                [configurationInput]="{
                  text: ('field.teamsCanView' | translate),
                  repositionDropdownList: true,
                  hasDelayedDefaultValue: true,
                }"
                [formControl]="addEditForm.controls.teams"
                [isLoading]="(store.teamOptionsLoading$ | async) === store.ELoadStatus.loading"
                (search)="getTeams($event)"
              ></mat-dropdown>
            </div>
            <div class="col-lg-12">
              <mat-checkbox [formControl]="addEditForm.controls.isPublished">
                {{ 'field.publishWorkspaceUsers' | translate }}
              </mat-checkbox>
            </div>
          </mat-expansion-panel>
        </div>

        <div class="col-12 mt-2">
          <app-screen-lock-configuration
            [durationControl]="addEditForm.controls.autoLockDuration"
            [pinControl]="addEditForm.controls.autoLockPin"
            [isExpanded]="isExtendedScreenLockPanel"
            [isFormSubmitted]="form.submitted"
            [isAutoLockConfigured]="isAutoLockConfigured"
            [showInheritanceHint]="true"
          ></app-screen-lock-configuration>
        </div>
      </div>
    </div>
    <mat-dialog-actions align="end">
      <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <button mat-flat-button type="submit">
        {{ addEditSubmitButtonText() }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>

<ng-template #fieldOptionName let-row="row">
  <div
    [class.pt-3]="(isDashboardFormInvalid && row.type === 'dashboard') || row.type === 'url'"
    [class.py-3]="!isDashboardFormInvalid && row.type === 'dashboard'"
  >
    @if (row.type === 'url') {
      <mat-form-field appearance="outline">
        <mat-label>{{ 'field.url' | translate }}</mat-label>
        <input matInput [formControl]="row.name" placeholder="https://..." />
        <mat-error [control]="row.name"></mat-error>
      </mat-form-field>
    } @else if (row.type === 'dashboard') {
      <mat-dropdown
        [isFormSubmitted]="isDashboardFormInvalid"
        [options]="store.dashboardsOptions()"
        [configurationInput]="{
          enableSearchFilter: true,
          hasDelayedDefaultValue: true,
          isClientSide: true,
          repositionDropdownList: true,
          singleSelection: true,
          hasMatError: isDashboardFormInvalid,
          text: this.translate.instant('field.dashboard'),
        }"
        [formControl]="row.name"
      ></mat-dropdown>
    }
  </div>
</ng-template>

<ng-template #fieldOptionDelete let-row="row">
  <button
    mat-mini-fab
    type="button"
    class="v-middle"
    (click)="deleteDashboardOption(row.id)"
    [disabled]="dashboardOptionsDatatableRows().length < 3"
    [matTooltip]="'button.remove' | translate"
  >
    <mat-icon>delete</mat-icon>
  </button>
</ng-template>
